import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cbb6d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import {
  brushReportApi,
  patientApi,
  periodontalReportApi,
  reportApi,
  screeningReportApi,
} from '@/shared/api'
import { REPORT_VIEW } from '@/shared/constants'
import { ReportViewType } from '@/shared/types'
import { showErrorMessage } from '@/shared/utils'
import { computed, PropType, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  reportId: Number,
  patientId: String,
  reportType: {
    type: Object as PropType<ReportViewType>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const loading = ref(false)

const pdfDownloadLink = computed(() => {
  let domain = window.origin

  if (process.env.NODE_ENV === 'production') {
    domain = process.env.VUE_APP_BASE_URI
  }

  switch (props.reportType) {
    case REPORT_VIEW.plaqueIndex:
      return `${domain}/api/web/admin/reports/report/download-from-service/${props.reportId}`
    case REPORT_VIEW.periodontal:
      return `${domain}/api/web/admin/periodontology/download-from-service/${props.reportId}`
    case REPORT_VIEW.brushMap:
      return `${domain}/api/web/admin/brush-maps/download-from-service/${props.reportId}`
    case REPORT_VIEW.screening:
      return `${domain}/api/web/admin/screening/download-from-service/${props.reportId}`
  }
})

const downloadPdf = async () => {
  if (loading.value) {
    return
  }

  loading.value = true
  let reportTypeName

  switch (props.reportType) {
    case REPORT_VIEW.periodontal:
      reportTypeName = 'Periodontology'
      break
    case REPORT_VIEW.brushMap:
      reportTypeName = 'Brushmap'
      break
    case REPORT_VIEW.screening:
      reportTypeName = 'Screening'
      break
    default:
      reportTypeName = 'Diana'
  }

  const date = new Date()
  let filename =
    date.getFullYear() +
    '.' +
    (date.getMonth() + 1) +
    '.' +
    date.getDate() +
    `-${reportTypeName}-`

  if (props.patientId !== 'null-patient') {
    const [patientError, patientResponse] = await patientApi.getPatientInfo(
      Number(props.patientId)
    )

    if (patientError) {
      showErrorMessage(patientError)
      loading.value = false
      return
    }

    const patientData = patientResponse.data.patient

    filename +=
      patientData.surname +
      ' ' +
      patientData.name +
      ' ' +
      patientData.patronymic +
      '.pdf'
  } else {
    filename += 'Без пациента.pdf'
  }

  let api: any

  switch (props.reportType) {
    case REPORT_VIEW.plaqueIndex:
      api = reportApi
      break
    case REPORT_VIEW.periodontal:
      api = periodontalReportApi
      break
    case REPORT_VIEW.brushMap:
      api = brushReportApi
      break
    case REPORT_VIEW.screening:
      api = screeningReportApi
      break
    default:
      api = null
  }

  if (!api) {
    showErrorMessage({ errors: ['Неправильный тип отчета'], status: 0 })
    return
  }

  const [error, response] = await api.downloadPdf(props.reportId)

  if (error) {
    showErrorMessage(error)
    loading.value = false
    return
  }

  try {
    const blob = new Blob([response], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  } catch (e) {
    showErrorMessage({ errors: ['Ошибка при создании PDF'], status: 500 })
  }

  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!

  return (_openBlock(), _createElementBlock("a", {
    href: _unref(pdfDownloadLink),
    class: _normalizeClass(loading.value ? 'download-report_loading' : 'download-report'),
    onClick: _withModifiers(downloadPdf, ["prevent"]),
    download: "plaque_index_report.pdf"
  }, [
    _createVNode(_component_icon_template, {
      class: "download-report__icon",
      height: "12",
      name: "download",
      width: "12"
    }),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Скачать"))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Идет загрузка"))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})